import routes from "@/router/routes";

import { RouterAppGuard } from "./router_guard/RouterAppGuard";

function RouterApp(): JSX.Element {
  return <RouterAppGuard routes={routes} />;
}

export default RouterApp;
